import { create } from "zustand";

export type CompassScope = "local" | "compass-wide";

interface CompassState {
    compassScope: CompassScope;
    setCompassScope: (scope: CompassScope) => void;
}

const useCompassStore = create<CompassState>((set) => ({
    compassScope: "compass-wide",
    setCompassScope: (scope: CompassScope) => set({ compassScope: scope }),
}));

export default useCompassStore;
